import React, { useState, useEffect, useCallback } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Slider from '@material-ui/core/Slider';
import { Divider } from "@material-ui/core";
import CachedIcon from '@material-ui/icons/Cached';

const useStyles = makeStyles(theme => ({
  root: {
    width: "450px",
    padding: "20px",
    overflow: "hidden",
  },
  centerElement: {
    textAlign: "center",
  },
  cursor: {
    cursor: "pointer",
  },
  floatRight: {
    float: "right",
    cursor: "pointer",
  }
}));


const KeyGen = props => {
  const classes = useStyles();
  const [length, setLength] = useState(16);
  const [password, setPassword] = useState("");
  const [simplePassword, setSimplePassword] = useState("");

  const buildPassword = useCallback(() => {
    let a = [],
        b = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        c = "abcdefghijklmnopqrstuvwxyz",
        d = "1234567890",
        e = "!@#$%^&*()";
    for (let i = 0; i < length; i++) {
      a[i] = b.charAt(Math.floor(Math.random() * b.length));
    }
    for (let i = 0; i < length; i++) {
      a[i] = a[i] + c.charAt(Math.floor(Math.random() * c.length));
    }
    for (let i = 0; i < length; i++) {
      a[i] = a[i] + d.charAt(Math.floor(Math.random() * d.length));
    }
    for (let i = 0; i < length; i++) {
      a[i] = a[i] + e.charAt(Math.floor(Math.random() * e.length));
    }
    setPassword(a.sort(() => Math.random() - 0.5).join(""));
  }, [length]);

  useEffect(() => {
    getSimplePassword();
    buildPassword();
  }, [buildPassword]);

  const getSimplePassword = () => {
    fetch('https://www.dinopass.com/password/strong')
      .then(res => res.text())
      .then(text => setSimplePassword(text));
  };

  useEffect(() => {
    buildPassword();
  }, [buildPassword]);



  return (
    <Grid container spacing={0} className={classes.root}>
      <Grid item xs={12}>
        <h5>Strong Password</h5>
        <CachedIcon className={classes.floatRight} onClick={getSimplePassword}/>
        <h3 className={classes.cursor} onClick={()=>{props.setPassword(simplePassword);}}>{ simplePassword }</h3>
        <Divider/>
        <h5>Advanced Password</h5>
        <CachedIcon className={classes.floatRight} onClick={buildPassword}/>
        <h3 className={classes.cursor} onClick={()=>{props.setPassword(password);}}>{ password }</h3>
      </Grid>
      <Grid item xs={12} className={classes.centerElement}>        
        <Slider
            value={length}
            min={8}
            max={32}
            onChange={(event, newValue) => {setLength(newValue);}}
        />
        <h5>Length: { length } Characters</h5>
      </Grid>
    </Grid>
  );
};

export default KeyGen;
